"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var parts_1 = require("../components/parts");
function default_1(series) {
    var centerBlock;
    if (series) {
        series.forEach(function (individualSeries, seriesIndex) {
            var seriesChildren = React.Children.toArray(individualSeries.props.children);
            seriesChildren.forEach(function (child) {
                if (child.type === parts_1.CenterBlock) {
                    centerBlock = child;
                }
            });
        });
    }
    return centerBlock;
}
exports.default = default_1;
//# sourceMappingURL=getCenterBlock.js.map